import React from 'react';

const Checkout = () => {
  return (
    <div style={styles.container}>
      <h2 style={styles.sectionTitle}>Conócenos</h2>
      <div style={styles.row}>
        <div style={styles.text}>
          <p>
            Somos una institución de educación privada que se caracteriza por su compromiso en la búsqueda permanente de la excelencia académica, con una trayectoria de 30 años de experiencia en el mercado; dedicada a la formación de profesionales dotados con las competencias necesarias para su desarrollo profesional, capaces de interactuar en el entorno social conjugando conocimientos, ética y responsabilidad hacia la sociedad y el medio ambiente.
          </p>
          <button style={styles.button}>Conoce más</button>
        </div>
        <img src="/img/sobrenosotros.jpg" alt="Sobre Nosotros" style={styles.image} />
      </div>

      <h2 style={styles.sectionTitle}>Misión</h2>
      <div style={styles.rowReverse}>
        <img src="/img/LogoPC.jpg" alt="Misión" style={styles.image} />
        <div style={styles.text}>
          <p>
            Somos una institución de educación privada que se caracteriza por su compromiso en la búsqueda permanente de la excelencia académica, dedicada a la formación de profesionales, capaces de interactuar en el entorno social conjugando conocimientos, técnicas, aptitudes y valores que se traduzcan en una actuación competitiva orientada a ofrecer opciones diferentes, útiles y realistas en el campo laboral.
          </p>
        </div>
      </div>

      <h2 style={styles.sectionTitle}>Visión</h2>
      <div style={styles.row}>
        <div style={styles.text}>
          <p>
            Grupo Impulsor será reconocido por contar con una propuesta educativa de alta calidad, consolidándonos así como la mejor institución de formación para el trabajo y el desarrollo humano, expertos en educar mediante estrategias educativas con base en el enfoque por competencias, actuando siempre con valores y responsabilidad social.
          </p>
        </div>
        <img src="/img/mision.jpg" alt="Visión" style={styles.image} />
      </div>

      <h2 style={styles.sectionTitle}>Director</h2>
      <div style={styles.rowReverse}>
        <img src="/img/Director.jpg" alt="director" style={styles.image} />
        <div style={styles.text}>
          <h3 style={styles.name}>Director General</h3>
          <p>
            Nuestro director general lidera con una visión transformadora y compromiso hacia la excelencia educativa, promoviendo un ambiente de innovación, ética y formación integral.
          </p>
          <button style={styles.button}>Conoce más</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#F8F9FA',
    padding: '50px 20px',
    fontFamily: 'Arial, sans-serif',
  },
  sectionTitle: {
    textAlign: 'center',
    fontSize: '28px',
    color: '#1F3D57',
    margin: '50px 0 30px',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginBottom: '40px',
    gap: '30px',
  },
  rowReverse: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap-reverse',
    marginBottom: '40px',
    gap: '30px',
  },
  text: {
    flex: '1',
    minWidth: '300px',
    maxWidth: '500px',
    fontSize: '16px',
    lineHeight: '1.6',
    color: '#333',
    textAlign: 'justify',
  },
  image: {
    flex: '1',
    minWidth: '280px',
    maxWidth: '400px',
    width: '100%',
    height: 'auto',
    borderRadius: '10px',
  },
  button: {
    marginTop: '15px',
    padding: '10px 20px',
    backgroundColor: '#1F3D57',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    fontSize: '14px',
    cursor: 'pointer',
  },
  name: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#1F3D57',
    marginBottom: '10px',
  },
};

export default Checkout;
